import * as keyapis_audit_v1_events_pb from "./v1/keyapis_audit_events_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_audit_v1_events_pb,
    },
  },
};
